module.exports = __webpack_public_path__ + "media/י.c6e47b80.mp3";